<template>
    <div class="search flex-all pl-3">
        <div class="relative">
            <div class="write d-flex align-items-center justify-content-start">
                <i class="ico-search larger pointer dark" @click="searchTicket"></i>
                <input type="text" class="query dark fs-small" v-model="query" @keyup.enter="searchTicket" placeholder="Search ticket number">
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        data() {
            return {
                query: '',
            }
        },
        methods: {
            ...mapActions([
                'openReservationById'
            ]),
            searchTicket(e) {
                if (!this.query) return;

                if (this.$route.name === 'pluralo.reservation.reschedule') {
                    this.$dialog.confirm(`
                        <div class="d-flex flex-column justify-content-center">
                            <div class="fs-large font-weight-600 mb-4">You are about to exit the rebooking process and begin a new reservation!</div>
                            <div class="dark">Are you sure you want to proceed?</div>
                        </div>`,
                        { okText: 'Yes', cancelText: 'No' }
                    ).then(() => {
                        this.$router.push({ path: '/reservations/view/' + this.query });
                    }).catch(() => {});
                } else {
                    this.openReservationById(this.query)
                } 
            }
        }
    }
</script>

<style lang="scss">
    @import '../../assets/scss/_variables.scss';

    .bar {
        .search {
            .write {
                input {
                    border: 0;
                    width: 100%;
                    line-height: 1em;
                    margin: 0;
                }
            }

            .results {
                position: absolute;
                top: 80%;
                left: 0;
                z-index: 5;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Search.vue?13f2d376